import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full max-w-lg rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "mb-2 text-catering-ink-900" }
const _hoisted_3 = { class: "text-catering-ink-500" }
const _hoisted_4 = { class: "overflow-x-auto" }
const _hoisted_5 = { class: "w-full text-left text-xs" }
const _hoisted_6 = { class: "divide-y divide-catering-cream-300" }
const _hoisted_7 = { class: "py-1.5 pr-2" }
const _hoisted_8 = { class: "py-1.5 pr-2 text-right tabular-nums" }
const _hoisted_9 = { class: "py-1.5 text-right tabular-nums" }
const _hoisted_10 = { class: "mt-2 text-[11px] text-catering-ink-500" }


export default {
  __name: 'BotCustomerSegments',
  props: { block: { type: Object, required: true } },
  setup(__props) {



const LABELS = {
  single_order_recent: 'Single order · recent',
  single_order_lapsed: 'Single order · lapsed',
  repeat_active: 'Repeat · active',
  repeat_lapsed: 'Repeat · lapsed'
}
const bucketLabel = key => LABELS[key] || key

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Customer segments", -1)),
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(__props.block.total_customers_with_paid_orders) + " paying " + _toDisplayString(__props.block.total_customers_with_paid_orders === 1 ? 'customer' : 'customers') + " ", 1),
      _createElementVNode("span", _hoisted_3, "(lapsed after " + _toDisplayString(__props.block.lapsed_after_days) + " days)", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
          _createElementVNode("tr", { class: "text-catering-ink-500" }, [
            _createElementVNode("th", { class: "py-1 pr-2 font-medium" }, "Segment"),
            _createElementVNode("th", { class: "py-1 pr-2 text-right font-medium" }, "Customers"),
            _createElementVNode("th", { class: "py-1 text-right font-medium" }, "Opted out")
          ])
        ], -1)),
        _createElementVNode("tbody", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.buckets || [], (b) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: b.name,
              class: "text-catering-ink-800"
            }, [
              _createElementVNode("td", _hoisted_7, _toDisplayString(bucketLabel(b.name)), 1),
              _createElementVNode("td", _hoisted_8, _toDisplayString(b.customers), 1),
              _createElementVNode("td", _hoisted_9, _toDisplayString(b.opted_out), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("p", _hoisted_10, " Marketing blocked: " + _toDisplayString(__props.block.marketing_blocked_total) + " · Do-not-text: " + _toDisplayString(__props.block.do_not_text_total), 1)
  ]))
}
}

}